import { articleExcerpt } from "@/mocks/articleData";
import { Link } from "react-router-dom";

export default function ArticlePreview() {
  return (
    <section className="bg-secondary-100/40 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">
          <div className="lg:w-[70%]">
            <span className="inline-block px-4 py-1.5 bg-background-50 rounded-full text-xs font-semibold text-foreground-700 mb-6 tracking-wider">
              GUIDE
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-extrabold text-foreground-950 leading-tight mb-10">
              CSSBuy Sheet Explained<br />The 2026 Zero-Risk Guide
            </h2>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-10">
              {articleExcerpt.highlights.map((h) => (
                <div key={h.title}>
                  <h4 className="text-sm font-semibold text-foreground-900 mb-1">{h.title}</h4>
                  <p className="text-xs text-foreground-600 leading-relaxed">{h.description}</p>
                </div>
              ))}
            </div>

            <p className="text-foreground-700 leading-relaxed mb-4 text-sm md:text-base">
              The world of agent shopping has evolved dramatically over the past few years. What once required manual tracking across multiple platforms can now be streamlined through a single <strong>CSSBuy spreadsheet</strong> system that centralizes your entire purchasing workflow. Our <Link to="/articles/cssbuy-sheet-complete-guide" className="text-primary-600 underline hover:text-primary-700">spreadsheet system overview</Link> reveals how smart buyers are cutting costs by up to 40% while maintaining complete visibility over every order.
            </p>
            <p className="text-foreground-700 leading-relaxed mb-4 text-sm md:text-base">
              Whether you are comparing the <strong>CSSBuy spreadsheet</strong> against the <strong>Kakobuy spreadsheet</strong> or evaluating how the <strong>Superbuy spreadsheet</strong> stacks up to the <strong>Oopbuy spreadsheet</strong>, having the right comparison framework makes all the difference. Each platform offers unique advantages, and our comprehensive guide breaks down exactly which system fits your specific needs.
            </p>
            <p className="text-foreground-700 leading-relaxed mb-8 text-sm md:text-base">
              From automated QC tracking to intelligent shipping optimization, the modern spreadsheet approach transforms chaotic multi-agent ordering into a clean, manageable process. Thousands of experienced buyers have already made the switch, and the results speak for themselves: faster processing, fewer errors, and significantly lower total costs. <Link to="/" className="text-primary-600 underline hover:text-primary-700">Return to the CSSSpreadsheet homepage</Link> to explore all our resources.
            </p>

            <Link
              to="/articles/cssbuy-sheet-complete-guide"
              className="inline-flex items-center gap-2 px-6 py-3 border-2 border-primary-500 text-primary-600 rounded-md text-sm font-semibold hover:bg-primary-50 transition-colors cursor-pointer whitespace-nowrap"
            >
              Read Full CSSBuy Sheet Guide
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </Link>
          </div>

          <div className="lg:w-[30%]">
            <div className="sticky top-28 bg-background-50/70 backdrop-blur-sm rounded-2xl border border-background-200/60 p-6">
              <h4 className="font-label text-xs font-semibold uppercase tracking-wider text-foreground-500 mb-4">In This Guide</h4>
              <nav className="flex flex-col gap-3">
                <Link to="/articles/cssbuy-sheet-complete-guide" className="text-sm text-foreground-700 hover:text-primary-600 transition-colors">
                  1. Getting Started with Spreadsheet Shopping
                </Link>
                <Link to="/articles/cssbuy-sheet-complete-guide" className="text-sm text-foreground-700 hover:text-primary-600 transition-colors">
                  2. Setting Up Your First CSSBuy Sheet
                </Link>
                <Link to="/articles/cssbuy-sheet-complete-guide" className="text-sm text-foreground-700 hover:text-primary-600 transition-colors">
                  3. Multi-Agent Comparison Framework
                </Link>
                <Link to="/articles/cssbuy-sheet-complete-guide" className="text-sm text-foreground-700 hover:text-primary-600 transition-colors">
                  4. QC Tracking & Automation
                </Link>
                <Link to="/articles/cssbuy-sheet-complete-guide" className="text-sm text-foreground-700 hover:text-primary-600 transition-colors">
                  5. Shipping Cost Optimization
                </Link>
                <Link to="/articles/cssbuy-sheet-complete-guide" className="text-sm text-foreground-700 hover:text-primary-600 transition-colors">
                  6. Advanced Tips & Best Practices
                </Link>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}